import { menuGroup, menuItem } from "modules/helpers";

// components
import Modal from "./Modal.doc";
import ModalAdd from "./ModalAdd.doc";
import ModalConfirmation from "./ModalConfirmation.doc";
import ModalDelete from "./ModalDelete.doc";
import ModalEdit from "./ModalEdit.doc";
import ModalInformation from "./ModalInformation.doc";
import ModalUpload from "./ModalUpload.doc";
import PopoverModal from "./PopoverModal.doc";

const components = [
  menuItem("<Modal/>", "modal", Modal),
  menuItem("<Modal.Add/>", "modal-add", ModalAdd),
  menuItem("<Modal.Confirmation/>", "modal-confirmation", ModalConfirmation),
  menuItem("<Modal.Delete/>", "modal-delete", ModalDelete),
  menuItem("<Modal.Edit/>", "modal-edit", ModalEdit),
  menuItem("<Modal.Information/>", "modal-information", ModalInformation),
  menuItem("<Modal.Upload/>", "modal-upload", ModalUpload),
  menuItem("<PopoverModal/>", "popover-modal", PopoverModal),
];

export default [menuGroup("Components", "components", components)];
